/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: unknown; output: unknown; }
  join__FieldSet: { input: unknown; output: unknown; }
  link__Import: { input: unknown; output: unknown; }
}

export interface BatchProgressInput {
  /** Course ID */
  courseId: Scalars['Int']['input'];
  /** Training instance ID */
  instanceId: Scalars['String']['input'];
  /** Slide views to save */
  slides: Array<LastViewInput>;
}

/** Completion reason */
export enum CompletionReason {
  MANUAL_OVERRIDE = 'MANUAL_OVERRIDE',
  PORTED_FROM_LEGACY = 'PORTED_FROM_LEGACY',
  QUIZZES_PASSED = 'QUIZZES_PASSED',
  SLIDES_VIEWED = 'SLIDES_VIEWED'
}

export interface CourseProgressInput {
  /** Course complete? */
  complete: Scalars['Boolean']['input'];
  /** Course ID */
  courseId: Scalars['Int']['input'];
  /** Training instance ID */
  instanceId: Scalars['String']['input'];
  /** Last view */
  lastView?: InputMaybe<LastViewInput>;
  /** Module progress */
  moduleProgress: Array<ModuleProgressInput>;
  /** Passed quizzes */
  passedQuizzes: Scalars['Int']['input'];
  /** Total quizzes */
  totalQuizzes: Scalars['Int']['input'];
  /** Total seconds */
  totalSeconds: Scalars['Int']['input'];
  /** Total slides */
  totalSlides: Scalars['Int']['input'];
  /** User ID */
  userId: Scalars['Int']['input'];
  /** Viewed seconds */
  viewedSeconds: Scalars['Int']['input'];
  /** Viewed slides */
  viewedSlides: Scalars['Int']['input'];
}

/** Course type */
export enum CourseType {
  Demo = 'Demo',
  Production = 'Production',
  QC = 'QC'
}

/** Dashboard name */
export enum DashboardName {
  ClosedCaptions = 'ClosedCaptions',
  Mobile = 'Mobile',
  StudentReport = 'StudentReport',
  Web = 'Web'
}

export interface LastViewInput {
  /** Date/time of view */
  dateTimeViewed: Scalars['String']['input'];
  /** Time in slide */
  resumeTime: Scalars['String']['input'];
  /** Slide UUID */
  slideId: Scalars['String']['input'];
}

export interface ModuleProgressInput {
  /** Confidence rating */
  confidenceRating?: InputMaybe<Rating>;
  /** Module full number */
  fullNumber: Scalars['String']['input'];
  /** Module ID */
  id: Scalars['String']['input'];
  /** Module name */
  name: Scalars['String']['input'];
  /** Quiz score */
  quizScore?: InputMaybe<Scalars['Int']['input']>;
  /** Total slides */
  totalSlides: Scalars['Int']['input'];
  /** Module type */
  type: moduleType;
  /** Viewed slides */
  viewedSlides: Scalars['Int']['input'];
}

/** Quiz provider */
export enum QuizProvider {
  Learnosity = 'Learnosity',
  None = 'None',
  QMS = 'QMS'
}

/** Confidence rating */
export enum Rating {
  CONFIDENT = 'CONFIDENT',
  NOT_CONFIDENT = 'NOT_CONFIDENT',
  SOMEWHAT_CONFIDENT = 'SOMEWHAT_CONFIDENT',
  UNANSWERED = 'UNANSWERED'
}

export interface RosterUserStartAfter {
  /** Start after expiration */
  expires?: InputMaybe<Scalars['String']['input']>;
  /** Start after ID */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Start after type */
  userType: UserType;
}

/** User type */
export enum UserType {
  ActiveUser = 'ActiveUser',
  ExpiredUser = 'ExpiredUser',
  InitUser = 'InitUser'
}

/** Cloudflare signed URL purpose: streaming (default) or download */
export enum VideoPurpose {
  DOWNLOAD = 'DOWNLOAD',
  STREAMING = 'STREAMING'
}

/** Video Resolution */
export enum VideoResolution {
  FHD = 'FHD',
  HD = 'HD',
  SD = 'SD',
  VBR = 'VBR'
}

export enum join__Graph {
  ASSETS = 'ASSETS',
  BOOKMARKS = 'BOOKMARKS',
  CONFIDENCE = 'CONFIDENCE',
  COURSE = 'COURSE',
  LEGACY = 'LEGACY',
  NOTES = 'NOTES',
  PROGRESS = 'PROGRESS',
  QUIZ = 'QUIZ',
  SEARCH = 'SEARCH',
  VIDEO = 'VIDEO'
}

export enum link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  EXECUTION = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  SECURITY = 'SECURITY'
}

/** Module type */
export enum moduleType {
  CONTENT = 'CONTENT',
  INTRO = 'INTRO',
  QUIZ = 'QUIZ',
  SURVEY = 'SURVEY'
}
